import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { fullDate } from 'Consts/DateFormats';
import View from './View';

const FileRow = ({
  fileURL, fileName, createdAt, createdBy, resource, onRemoveFile,
}) => {
  return (
    <View
      fileURL={fileURL}
      fileName={fileName}
      createdAt={moment(createdAt).utc().format(fullDate)}
      createdBy={createdBy}
      resource={resource}
      onRemoveFile={onRemoveFile}
    />
  );
};

FileRow.propTypes = {
  fileURL: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

export default FileRow;
